<template>
    <v-container grid-list-md>
        <v-layout row align-center justify-center mt-4 v-if="loading">
            <tile :loading="true" color="primary"></tile>
        </v-layout>

        <form v-on:submit.prevent="update" v-if="! loading">

            <v-layout row wrap>
                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.to"
                            :error-messages="errors.collect('data.to')"
                            label="To"
                            data-vv-name="data.to"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.vat"
                            :error-messages="errors.collect('data.vat')"
                            label="Vat"
                            data-vv-name="data.vat"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-menu
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <v-text-field
                                v-validate="'required'"
                                slot="activator"
                                v-model="data.date"
                                :error-messages="errors.collect('data.date')"
                                label="Date"
                                data-vv-name="data.date"
                                readonly
                                browser-autocomplete="off"
                        ></v-text-field>
                        <v-date-picker v-model="data.date" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="''"
                            v-model="data.customer_code"
                            :error-messages="errors.collect('data.customer_code')"
                            label="Customer code"
                            data-vv-name="data.customer_code"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.from"
                            :error-messages="errors.collect('data.from')"
                            label="From"
                            data-vv-name="data.from"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.our_order_number"
                            :error-messages="errors.collect('data.our_order_number')"
                            label="Our order number"
                            data-vv-name="data.our_order_number"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.client_order_number"
                            :error-messages="errors.collect('data.client_order_number')"
                            label="Client order number"
                            data-vv-name="data.client_order_number"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.delivery_terms"
                            :error-messages="errors.collect('data.delivery_terms')"
                            label="Delivery terms"
                            data-vv-name="data.delivery_terms"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="''"
                            v-model="data.to_2"
                            :error-messages="errors.collect('data.to_2')"
                            label="To"
                            data-vv-name="data.to_2"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.payment_terms"
                            :error-messages="errors.collect('data.payment_terms')"
                            label="Payment terms"
                            data-vv-name="data.payment_terms"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.currency"
                            :error-messages="errors.collect('data.currency')"
                            label="Currency"
                            data-vv-name="data.currency"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-autocomplete
                            v-model="data.cliente_id"
                            :items="clients"
                            label="Client"
                            item-text="company_name"
                            item-value="id"
                            v-on:change="debouncedRellenarCampos()"
                            browser-autocomplete="off"
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.concept"
                            :error-messages="errors.collect('data.concept')"
                            label="Concept"
                            data-vv-name="data.concept"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs4 s4 md4>
                    <v-autocomplete
                            v-model="data.status_id"
                            :items="statuses"
                            label="Status"
                            item-text="name"
                            item-value="id"
                            browser-autocomplete="off"
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex xs12 md12>
                    <v-btn large color="secondary" class="text--primary" type="submit">Save</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    export default {
        props: ['order'],
        data : function() {
            return {
                data : {
                    date : '',
                    to: '',
                    vat: '',
                    customer_code: '',
                    from: 'Murcia, Spain',
                    client_order_number: '',
                    currency: '',
                    cliente_id: '',
                    concept: '',
                    our_order_number: '',
                    delivery_terms: '',
                    to_2: '',
                    payment_terms: '',
                    status_id: ''
                },
                error : false,
                message_error : null,
                dictionary: {
                    custom: {
                    }
                },
                clients: null,
                loading: true,
                menu: false,
                statuses: null
            }
        },
        created: function () {
            this.data = this.order;
            this.getClients();
            this.getStatuses();
            this.debouncedRellenarCampos = _.debounce(this.rellenarCampos, 100);
        },
        methods: {
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('updateOrder', {
                            id: this.order.id,
                            data : this.data
                        }).then((res) => {

                            this.$emit('updated')

                        }).catch((error) => {
                        });
                    }
                });

            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                    this.loading = false;
                }).catch((error) => {

                });
            },
            getStatuses () {
                this.$store.dispatch('getStatusOrders').then((res) => {

                    this.statuses = res.data.data;

                }).catch((error) => {

                });
            },
            rellenarCampos () {
                this.$store.dispatch('getClient', {
                    id: this.data.cliente_id
                }).then((res) => {
                    var state = res.data.state_name;
                    var billing = res.data.billing_data_default ? res.data.billing_data_default.billing_data : null;
                    var country = res.data.country_name;

                    if (state == '' && billing == null && country == '') {
                        this.data.to = res.data.company_name + '.';
                    }

                    if (state != '' && billing == null && country == '') {
                        this.data.to = res.data.company_name + ', ' + state + '.';
                    }

                    if (state == '' && billing == null && country != '') {
                        this.data.to = res.data.company_name + ', ' + country + '.';
                    }

                    if (state != '' && billing == null && country != '') {
                        this.data.to = res.data.company_name + ', ' + state +  ', ' + country + '.';
                    }

                    if (state == '' && country == '' && billing != null) {
                        this.data.to = res.data.company_name + ', ' + billing + '.';
                    }

                    if (country == '' && state != '' && billing != null) {
                        this.data.to = res.data.company_name + ', ' + billing + ', ' + state + '.';
                    }

                    if (state == '' && country != '' && billing != null) {
                        this.data.to = res.data.company_name + ', ' + billing + ', ' + country + '.';
                    }

                    if (state != '' && country != '' && billing != null ) {
                        this.data.to = res.data.company_name + ', ' + billing + ', ' + state + ', ' + res.data.country_name + '.';
                    }

                    this.data.vat = res.data.vat;
                }).catch((error) => {

                });
            },
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/orders/views/OrderComponent.vue